<script>
export default {
  name: 'LegacyWhiteBox',
  props: {
    title: { type: String, default: '' },
    subText: { type: String, default: '' },
  },
}
</script>

<template>
  <div class="rounded-xl border border-border bg-card text-card-foreground shadow-sm">
    <div
      v-if="title || subText || $slots.buttons"
      class="flex items-start justify-between p-4 border-b border-border"
    >
      <div>
        <h3 v-if="title" class="text-base font-semibold text-foreground">{{ title }}</h3>
        <p v-if="subText" class="text-sm text-muted-foreground">{{ subText }}</p>
      </div>
      <div class="flex items-center gap-2">
        <slot name="buttons" />
      </div>
    </div>
    <div class="p-4">
      <slot name="content" />
      <slot />
    </div>
  </div>
</template>
